import { createApiClient, createQueriesConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
export const TOTAL_INSIGHT_BULLETS = 3;
const pickTwoDistinctIndexes = () => {
  const first = Math.floor(Math.random() * TOTAL_INSIGHT_BULLETS);
  const offset = 1 + Math.floor(Math.random() * (TOTAL_INSIGHT_BULLETS - 1));
  return [first, (first + offset) % TOTAL_INSIGHT_BULLETS];
};
export const heroInsightBulletsApiConfig = createQueriesConfig({
  heroInsightBullets: {
    queryFn: async _ => ({
      insightIndexes: pickTwoDistinctIndexes()
    }),
    queryConfigType: QueryConfigTypes.FIXED_DATA
  }
});
export const heroInsightBulletsApiClient = createApiClient(heroInsightBulletsApiConfig);
//# sourceMappingURL=HeroInsightBullets.apiClient.js.map